import { bus } from "@/plugins/bus"
export default {
    data() {
        // Pour gérer le changement de langue dans les messages d'erreurs
        return { formActive: true }
    },
    computed:
    {
        required() { return this.formActive ? [v => !!v || this.$t('rules.champObligatoire')] : [] },
        requiredMultiple() { return this.formActive ? [(v) => v.length > 0 || this.$t('rules.champObligatoire')] : [] },
        requiredEmail() { return this.formActive ? [(v) => /.+@.+\..+/.test(v) || this.$t('rules.courrielNonValide')] : [] },
        codePostalRules() { return this.formActive ? [(v) => /^[A-Z]\d[A-Z] \d[A-Z]\d$/.test(v) || this.$t('rules.codePostalNonValide')] : [] },
        phoneRules() { return this.formActive ? [(v) => /^\(\d{3}\)\s\d{3}\s\d{4}$/.test(v) || this.$t('rules.telephoneNonValide')] : [] },
        optionalPhoneRules() { return this.formActive ? [(v) => !v || /^\(\d{3}\)\s\d{3}\s\d{4}$/.test(v) || this.$t('rules.telephoneNonValide')] : [] },
        montantDon() { return this.formActive ? [(v) => v > 0 || ""] : [] },
    },
    created() {
        bus.$on("updateLocale", this.updateLocale) // Pour gérer le changement de langue dans les messages d'erreurs
    },
    methods: {
        // Pour gérer le changement de langue dans les messages d'erreurs
        updateLocale() {
            this.formActive = false
            this.$nextTick(() => {
                this.formActive = true
            })
        },
    },
}
